<div class="page" [class.hide]="hide">
    <div class="main-menu no-print">
        @if (showMenu$ | async) {
            <left-menu class="height-100" />
        }
    </div>
    <div class="main-page">
        @if (isAuthenticated$ | async) {
            <main-header class="width-100" [simplifiedHeader]="customShell" />
        }
        <div class="page-content">
            <div class="main-container">
                <ng-content />
            </div>
            <div class="footer-container no-print pt-3 pb-3">
                <advizeo-footer />
            </div>
        </div>
    </div>
</div>
